(function() {
  exports.Crop = (function() {
    function Crop() {
      this.id = null;
      this.name = '';
      this.lineups_id = null;
      this.has_spp = false;
      this.edited_by = '';
      this.edited_at = '';
    }

    return Crop;

  })();

}).call(this);
